export default __webpack_public_path__ + "static/media/contact-banner.d3f26663.webp";